export default __webpack_public_path__ + "static/media/06_Business-PortraitArchitecture-InteriorEschweilerPhotography_M1A7277.5c82d2b2.jpg";